/**
 * On every page load, scroll to the top instantly (avoids the browser's
 * automatic restoration of the previous scroll position).
 *
 * Exception: when the URL carries a hash that points at a real element on the
 * page — e.g. arriving from an off-page section link such as /#reviews on the
 * privacy or cookie page — scroll to that section instead.
 *
 * Late-loading content (images, fonts) keeps shifting the layout for a moment
 * after `load`, so a single scroll lands short. We pin the target to the top of
 * the viewport for a brief window while the page settles, and bail the instant
 * the user scrolls so we never fight them for control.
 */
if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

window.addEventListener('load', function () {
    var hash = window.location.hash;
    var target = hash && hash.length > 1 ? document.getElementById(hash.slice(1)) : null;

    if (!target) {
        window.scrollTo(0, 0);
        return;
    }

    var cancelled = false;
    var SCROLL_KEYS = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar'];

    function stop() {
        cancelled = true;
        window.removeEventListener('wheel', stop);
        window.removeEventListener('touchstart', stop);
        window.removeEventListener('keydown', onKey);
    }

    function onKey(e) {
        if (SCROLL_KEYS.indexOf(e.key) !== -1) {
            stop();
        }
    }

    // Genuine user input cancels the pin (scrollIntoView itself never fires these).
    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchstart', stop, { passive: true });
    window.addEventListener('keydown', onKey);

    var start = Date.now();
    (function pin() {
        if (cancelled) {
            return;
        }
        target.scrollIntoView({ block: 'start' });
        if (Date.now() - start < 1500) {
            window.requestAnimationFrame(pin);
        } else {
            stop();
        }
    })();
});
